// extracted by mini-css-extract-plugin
export default {"label-input":"InputWithLabel_label-input__Imjz7","input-field":"InputWithLabel_input-field__X3cLi"};